import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material'; 

@Component({
  selector: 'app-pgobancario',
  templateUrl: './pgobancario.component.html',
  styleUrls: ['./pgobancario.component.css']
})
export class PgobancarioComponent implements OnInit {

  valorcheque: string;
  txttotalcheque: string;
  txtnumerocheque: string;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data,
    public dialogRef: MatDialogRef<PgobancarioComponent>,
  ) { }

  ngOnInit() {
      this.txtnumerocheque ="";
      this.txttotalcheque = this.data.costototal;
   
  }


  aceptapagocheque(){
    this.dialogRef.close({ aceptado: 'OK', numerocheque: this.txtnumerocheque });
  }

  cerrarventana() {
    console.log('entre a procedimienot cerrrar evntaba');
    // this.dialogRef.close({ aceptado: 'OK', cantidad: this.cantidades, monto: this.totalpagar, nuevoidprecompra: this.ultimoidprecompra, inventariototal: this.inventario });
  }

  cancelarventana() {
    this.dialogRef.close({ aceptado: 'False' });
  }


  

}
